module.exports = __webpack_public_path__ + "img/Icon_Link.765959cf.svg";